import { PaymentTypes } from '@lib/domain/payment';

export interface OrderInfo {
    order_number: string;
    desc: string;
    total: number;
    brand_type: string;
    payment_id: string;
    payment_status: string;
    id: string;
    is_signed_up: boolean;
    payment_type?: PaymentTypes;
}

export type Prices = {
    follower: number;
    like?: number;
    subscriber?: number;
    view?: number;
    comment?: number;
    share?: number;
    retweet?: number;
};

export type PriceTypes = Prices;

export enum Statuses {
    inprocess = 'in_progress',
    completed = 'completed',
    draft = 'draft',
    cancelled = 'canceled',
    waiting = 'Waiting',
    pending = 'pending',
    confirmed = 'confirmed',
}
export enum SmmServiceStatus {
    Pending = 'Pending',
    InProgress = 'In Progress',
    Completed = 'Completed',
    Partial = 'Partial',
    Processing = 'Processing',
    Canceled = 'Canceled',
    Error = 'Error',
    Waiting = 'Waiting',
    UnderReview = 'Under Review',
}
export interface OrderSubscription {
    post_id: number | string;
    status: SmmServiceStatus;
    post_on: string;
}

export interface OrderDashboardItem {
    type: 'normal' | 'subscription';
    title: string;
    url: string;
    status?: Statuses | SubscriptionStatus;
    subscriptionOrder?: OrderSubscription[];
    orderNumber?: string | number;
    start_count?: number;
    actionType: ActionTypes;
    quantity?: number;
}
export interface OrderSubscriptionDiscountResponse {
    url: string;
    price: number;
    status: SubscriptionStatus;
    brand_type: BrandTypes;
    action_type: ActionTypes;
    smm_order_id: string;
    new_posts: number;
    old_posts: string;
    current_posts: number;
    delay: number;
    expiry: Date;
    minimum: number;
    maximum: number;
    smm_orders: string[];
    original_price: number;
    created_at: Date;
    updated_at: Date;
    id: string;
}
export enum SubscriptionStatus {
    Draft = 'Draft',
    Active = 'Active',
    Paused = 'Paused',
    Completed = 'Completed',
    Expired = 'Expired',
    Canceled = 'Canceled',
}

export enum BrandTypes {
    youtube = 'youtube',
    tiktok = 'tiktok',
    facebook = 'facebook',
    instagram = 'instagram',
    twitter = 'twitter',
    twitch = 'twitch',
}

export enum ActionTypes {
    view = 'view',
    like = 'like',
    subscriber = 'subscriber',
    follower = 'follower',
    comment = 'comment',
    share = 'share',
    retweet = 'retweet',
    watchhour = 'watch_hour',
    user_follower = 'user_follower',
    live_stream_30_minutes = 'live_stream_30_minutes',
    live_stream_1_hour = 'live_stream_1_hour',
    live_stream_2_hours = 'live_stream_2_hours',
    live_stream_3_hours = 'live_stream_3_hours',
    live_stream_6_hours = 'live_stream_6_hours',
}

export enum ActionYoutubeTypes {
    view = 'view',
    like = 'like',
    subscriber = 'subscriber',
    comment = 'comment',
    share = 'share',
}

export enum ActionTiktokTypes {
    view = 'view',
    like = 'like',
    follower = 'follower',
    comment = 'comment',
    share = 'share',
}
export enum ActionTwitchTypes {
    view = 'view',
    liveView = 'live_view',
    follower = 'follower',
}
export enum ActionFacebookTypes {
    like = 'like',
    follower = 'follower',
    user_follower = 'user_follower',
}

export enum ActionTwitterTypes {
    follower = 'follower',
    like = 'like',
    comment = 'comment',
    retweet = 'retweet',
}

export enum ActionInstagramTypes {
    like = 'like',
    follower = 'follower',
    comment = 'comment',
    view = 'view',
}

export interface MessageCheck {
    msg: string | undefined;
    disabled: boolean;
}

export interface ServiceCheck {
    service_id: string;
    action_type: ActionTypes;
    enabled: boolean;
}

export interface OrderCheck {
    action_type: ActionTypes;
    count: number;
    url: string;
}

export interface CheckOrderResponse {
    services: ServiceCheck[];
    in_progress: OrderCheck[];
}
export interface CheckUpsellSubscriptionResponse {
    active: boolean;
}

export type Types =
    | 'views'
    | 'shares'
    | 'likes'
    | 'subscribers'
    | 'dedicatedComments'
    | 'watchhours';

export interface ServiceItem {
    status: Statuses;
    quantity: number;
    delivered: number;
    id: string | number;
    name: string;
    title: string;
    price: number;
    url: string;
    end_date?: Date | undefined;
}
export interface SumaryPayload {
    total: number;
    payment_id: string;
    brand_type: BrandTypes;
    payment_type?: PaymentTypes;
    payer_email_address?: string;
}

export interface OrderItemPost {
    url: string;
    quantity: number;
    price: number;
    action_type: ActionTypes;
}

export interface PaymenInstrument {
    pan: string;
    exp_year: number;
    exp_month: number;
    cvc: string;
    holder: string;
}

export interface Threeds2Data {
    notification_url: string;
    accept_header: string;
    browser_language: string;
    screen_width: number;
    screen_height: number;
    challenge_window_size: string;
    user_agent: string;
    color_depth: number;
    time_zone: string;
    ip_address: string;
}

export interface PurchaseOrderCardinityBody {
    amount: string;
    currency: string;
    order_id: string;
    country: string;
    payment_instrument: PaymenInstrument;
    // threeds2_data: Threeds2Data;
}
export interface discount {
    url: string;
    title: string;
    action_type: ActionTypes;
}
export interface OrderSubscriptionDiscountRequest {
    url: string;
    title: string;
    action_type: ActionTypes;
    quantity: number;
}
export interface Subscription {
    url: string;
    price: number;
    status: SubscriptionStatus;
    brand_type: BrandTypes;
    action_type: ActionTypes;
    smm_order_id: string;
    new_posts: number;
    old_posts: string;
    current_posts: number;
    delay: number;
    expiry: Date;
    minimum: number;
    maximum: number;
    smm_orders: string[];
    original_price: number;
    created_at: Date;
    updated_at: Date;
    id: string;
}

export interface OrderPost {
    summary: SumaryPayload;
    orders: OrderItemPost[];
    channel: string;
    discount?: discount;
    coupon_code?: string;
    subscription?: OrderSubscriptionDiscountRequest;
    order_summary_id?: string;
}

export interface OrderItem {
    url: string;
    desc: string;
    price: number;
    action_type: ActionTypes;
    oder_number: string;
    quantity: number;
    delivered: number;
    start_count: number;
    status: Statuses;
    brand_type: string;
    smm_order_id: string | null;
    smm_service_status: SmmServiceStatus;
    smm_service_name: string;
    retry: number;
    user: string | number;
    id: string;
    summary_id: string;
    discount?: boolean;
    payer_email_address?: string;
    created_at: string;
}
export interface Order {
    summary: {
        order_number: string;
        desc: string;
        total: string;
        brand_type: string;
        payment_id: string;
        payment_status: string;
        id: string;
        created_at: Date;
        payment_type?: PaymentTypes;
        channel?: string;
        payer_email_address?: string;
        coupon_code?: string;
        origin_total?: number;
    };
    orders: OrderItem[];
    subscriptions?: Subscription[];
}

type DefaultYoutubeItemProps = {
    price: number;
    quantity: number;
    discount: number;
};

export interface Pagination {
    total: number;
    page_index: number;
}

export interface PageInfo {
    page_index: number;
    page_size: number;
}

export type DefaultYoutubeProps = Record<Types, DefaultYoutubeItemProps>;

export interface OrderCompletePayload {
    payment_id: string;
    order_id?: string;
    payment_type: PaymentTypes;
    email?: string;
    brand_type?: string;
}

export interface CompleteOrderPayload {
    id: string;
}

export interface OrderWithEmail extends OrderPost {
    email?: string;
}

export interface BasePrice {
    price: number;
    quantity: number;
    discount: number;
}

export interface DisableData {
    [ActionTypes.follower]: { disabled: boolean; count: number };
    [ActionTypes.view]: { disabled: boolean; count: number };
    [ActionTypes.like]: { disabled: boolean; count: number };
    [ActionTypes.comment]?: { disabled: boolean; count: number };
    [ActionTypes.share]?: { disabled: boolean; count: number };
}

export interface OrderUser {
    id: string | number;
    name: string;
    nickname: string;
    username: string;
    avatar: string;
    convertImage?: boolean;
}

export interface UpdateOrderSummaryPayload {
    id: string;
    payer_email_address: string;
    coupon_code?: string;
}
export const enum UpsellActionType {
    // like = 'like',
    follower = 'follower',
    subscriber = 'subscriber',
}
